<template>
  <Loader
    :value="promises.fetchOne"
    :message="`${$t('loading', { resource: '' })}...`"
    class="residential-account-address-control"
  >
    <Modal :show.sync="show" class="residential-account-address-control__modal">
      <Card tag="form" theme="flat" @submit.prevent="submit">
        <template #default>
          <Address
            v-if="$path('project', item)"
            v-model="data.address"
            :default-address="$path('project.address', item)"
          />
          <Alert theme="warning" class="mt-3">
            {{ $t('residentialAddressControl') }}
          </Alert>
        </template>
        <template #footer>
          <ButtonComponent :label="$t('cancel')" type="button" @click="show = false" :icon="['fal', 'times']" />
          <ButtonComponent
            :label="$t('confirm')"
            theme="primary"
            type="submit"
            :promise="promises.mutate"
            :icon="['fal', 'check']"
          />
        </template>
      </Card>
    </Modal>
  </Loader>
</template>

<script>
import ModelMixin from '@/mixins/Model'
import { mapState, mapActions } from 'vuex'
import { i18n } from '@/i18n'

import Card from '@/components/Card'
import Address from '@/components/Residential/Fields/Address'
import { ModalComponent as Modal } from 'vue-elder-modal'
import { AlertComponent as Alert } from 'vue-elder-alert'
import Bus from '@/bus'

const meta = {
  order: 1,
  id: 'basis',
  label: i18n.tc('basis'),
  icon: ['fal', 'file-alt'],
}

export { meta }
export default {
  mixins: [
    ModelMixin({
      model: {
        id: null,
        address: {
          city: null,
          county: null,
          location: null,
          postcode: null,
          street: null,
        },
      },
    }),
  ],
  props: {
    id: String,
  },
  watch: {
    id: {
      handler() {
        return this.fetch()
      },
      immediate: true,
    },
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    ...mapState('Residential', ['item', 'promises']),
  },
  methods: {
    ...mapActions('Residential', {
      submit(dispatch) {
        return dispatch('mutate', [{ id: this.id, ...this.getData({ diff: true }) }, {}]).then(() => {
          this.show = false
          this.$emit('close')
        })
      },
      fetch(dispatch) {
        return dispatch('fetch', { id: this.id })
      },
    }),
  },
  created() {
    Bus.$on('show:address:control', () => {
      this.show = true
    })
  },

  components: {
    Card,
    Address,
    Modal,
    Alert,
  },
}
</script>

<style lang="scss">
.residential-account-address-control {
  .card__footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
